export const BOOKINGS_DATA = [
    {
        id: 13,
        date: '2025-03-23',
        bookingNo: 'BOOK001',
        destination: { id: 101, name: 'Chennai' },
        sender: { id: 201, name: 'Coimbatore' },
        receiver: { id: 301, name: 'Madurai' },
        items: [{ type: { id: 1, name: 'Parcel' }, item: 'Electronics', qty: 1, weight: 1, price: 1 }],
        freight: 750,
        surcharge: 30,
        stationary: 20,
        handling: 10,
        demurrage: 0,
        doorCollection: 40,
        doorDelivery: 50,
        insurance: 10,
        total_charge: 0,
        subtotal: 1,
        tax: 0.18,
        total: 1,
        comments: 'Basic shipment',
        llr: 'LLR001',
        consignor: 'Rohan',
        consignee: 'CUP',
        branch: 'VDI',
        destinationCode: 'EPM',
        payment_status: 0,
        discount: 10,
        packageStatus: 1,
        modeOfDelivery: 1,
        from: 'Palakkad',
        to: 'Coimbatore',
        lat: 16.9450,
        lng: 79.6619,
        title: 'Booking Title 1',
        description: 'Booking description 1',
        cancelNote: '',
        consignorDetails: {
            name: 'Rohan',
            address: '123 Main St, Chennai',
            phone: '9876543210',
            gst: '27ABCDE1234F1Z5'
        },
        consigneeDetails: {
            name: 'CUP',
            address: '456 Elm St, Mumbai',
            phone: '1234567890',
            gst: '27ABCDE5678F1Z5'
        },
        self_pickup: true,
        item_id: '12345',
        item_type: 'Electronics',
        item_price: 1000,
        item_invoice_value: 1200,
        item_invoice_date: '2025-11-01',
        item_invoice_no: 'INV123456',
        item_weight: 2.5,
        item_qty: 1,
        item_name: 'Laptop'
    },
    {
        id: 14,
        date: '2025-03-24',
        bookingNo: 'BOOK002',
        destination: { id: 102, name: 'Mumbai' },
        sender: { id: 202, name: 'Chennai' },
        receiver: { id: 302, name: 'Delhi' },
        items: [{ type: { id: 2, name: 'Cargo' }, item: 'Clothes', qty: 2, weight: 5, price: 2 }],
        freight: 800,
        surcharge: 40,
        stationary: 25,
        handling: 15,
        demurrage: 0,
        doorCollection: 35,
        doorDelivery: 45,
        insurance: 15,
        total_charge: 0,
        subtotal: 2,
        tax: 0.18,
        total: 2,
        comments: 'Express shipment',
        llr: 'LLR002',
        consignor: 'Suresh',
        consignee: 'Karthik',
        branch: 'MUM',
        destinationCode: 'DEL',
        payment_status: 1,
        discount: 5,
        packageStatus: 2,
        modeOfDelivery: 2,
        from: 'Mumbai',
        to: 'Delhi',
        lat: 19.0760,
        lng: 72.8777,
        title: 'Booking Title 2',
        description: 'Booking description 2',
        cancelNote: '',
        consignorDetails: {
            name: 'Suresh',
            address: '123 MG Road, Mumbai',
            phone: '9876512345',
            gst: '27ABCDE0000F1Z9'
        },
        consigneeDetails: {
            name: 'Karthik',
            address: '100 Park St, Delhi',
            phone: '9123456789',
            gst: '07ABCDE1111F2Z0'
        },
        self_pickup: false,
        item_id: '23456',
        item_type: 'Clothing',
        item_price: 800,
        item_invoice_value: 900,
        item_invoice_date: '2025-11-02',
        item_invoice_no: 'INV123457',
        item_weight: 5.0,
        item_qty: 2,
        item_name: 'Shirts'
    },
    {
        id: 15,
        date: '2025-03-25',
        bookingNo: 'BOOK003',
        destination: { id: 103, name: 'Hyderabad' },
        sender: { id: 203, name: 'Bangalore' },
        receiver: { id: 303, name: 'Vizag' },
        items: [{ type: { id: 3, name: 'Machinery' }, item: 'Pump', qty: 1, weight: 10, price: 3 }],
        freight: 1000,
        surcharge: 30,
        stationary: 15,
        handling: 20,
        demurrage: 10,
        doorCollection: 30,
        doorDelivery: 60,
        insurance: 20,
        total_charge: 0,
        subtotal: 3,
        tax: 0.18,
        total: 3,
        comments: 'Heavy item',
        llr: 'LLR003',
        consignor: 'Anil',
        consignee: 'Raj',
        branch: 'HYD',
        destinationCode: 'VZG',
        payment_status: 0,
        discount: 0,
        packageStatus: 0,
        modeOfDelivery: 1,
        from: 'Bangalore',
        to: 'Vizag',
        lat: 17.3850,
        lng: 78.4867,
        title: 'Booking Title 3',
        description: 'Booking description 3',
        cancelNote: '',
        consignorDetails: {
            name: 'Anil',
            address: '50 Hilltop, Bangalore',
            phone: '9876598765',
            gst: '29ABCDE2222F3Z1'
        },
        consigneeDetails: {
            name: 'Raj',
            address: '99 Beach Rd, Vizag',
            phone: '9876543212',
            gst: '37ABCDE3333F4Z2'
        },
        self_pickup: false,
        item_id: '34567',
        item_type: 'Pump',
        item_price: 1500,
        item_invoice_value: 1600,
        item_invoice_date: '2025-11-03',
        item_invoice_no: 'INV123458',
        item_weight: 10.0,
        item_qty: 1,
        item_name: 'Water Pump'
    },
    {
        id: 16,
        date: '2025-03-26',
        bookingNo: 'BOOK004',
        destination: { id: 104, name: 'Pune' },
        sender: { id: 204, name: 'Surat' },
        receiver: { id: 304, name: 'Nagpur' },
        items: [{ type: { id: 4, name: 'Spare Parts' }, item: 'Engine Parts', qty: 3, weight: 8, price: 4 }],
        freight: 920,
        surcharge: 25,
        stationary: 20,
        handling: 15,
        demurrage: 0,
        doorCollection: 20,
        doorDelivery: 30,
        insurance: 12,
        total_charge: 0,
        subtotal: 4,
        tax: 0.18,
        total: 4,
        comments: 'Mechanical load',
        llr: 'LLR004',
        consignor: 'Manoj',
        consignee: 'Irfan',
        branch: 'PUN',
        destinationCode: 'NGP',
        payment_status: 1,
        discount: 20,
        packageStatus: 1,
        modeOfDelivery: 2,
        from: 'Surat',
        to: 'Nagpur',
        lat: 18.5204,
        lng: 73.8567,
        title: 'Booking Title 4',
        description: 'Booking description 4',
        cancelNote: '',
        consignorDetails: {
            name: 'Manoj',
            address: '32 Factory Rd, Surat',
            phone: '9876543012',
            gst: '24ABCDE4567F8Z9'
        },
        consigneeDetails: {
            name: 'Irfan',
            address: '88 Hilltop, Nagpur',
            phone: '8765432101',
            gst: '27ABCDE6789F1Z1'
        },
        self_pickup: false,
        item_id: '45678',
        item_type: 'Auto Parts',
        item_price: 700,
        item_invoice_value: 750,
        item_invoice_date: '2025-11-04',
        item_invoice_no: 'INV123459',
        item_weight: 8.0,
        item_qty: 3,
        item_name: 'Brake Pads'
    },
    {
        id: 17,
        date: '2025-03-27',
        bookingNo: 'BOOK005',
        destination: { id: 105, name: 'Ahmedabad' },
        sender: { id: 205, name: 'Indore' },
        receiver: { id: 305, name: 'Jaipur' },
        items: [{ type: { id: 5, name: 'Raw Material' }, item: 'Steel Rods', qty: 6, weight: 15, price: 5 }],
        freight: 1050,
        surcharge: 50,
        stationary: 30,
        handling: 20,
        demurrage: 10,
        doorCollection: 25,
        doorDelivery: 35,
        insurance: 18,
        total_charge: 0,
        subtotal: 5,
        tax: 0.18,
        total: 5,
        comments: 'Steel shipment',
        llr: 'LLR005',
        consignor: 'Kailash',
        consignee: 'Deepak',
        branch: 'AMD',
        destinationCode: 'JPR',
        payment_status: 0,
        discount: 0,
        packageStatus: 2,
        modeOfDelivery: 1,
        from: 'Indore',
        to: 'Jaipur',
        lat: 23.0225,
        lng: 72.5714,
        title: 'Booking Title 5',
        description: 'Booking description 5',
        cancelNote: '',
        consignorDetails: {
            name: 'Kailash',
            address: '21 Steel Market, Indore',
            phone: '9876543013',
            gst: '23ABCDE7890F2Z3'
        },
        consigneeDetails: {
            name: 'Deepak',
            address: '66 Amber Rd, Jaipur',
            phone: '8901234568',
            gst: '08ABCDE3456F3Z2'
        },
        self_pickup: false,
        item_id: '56789',
        item_type: 'Steel Material',
        item_price: 1500,
        item_invoice_value: 1650,
        item_invoice_date: '2025-11-05',
        item_invoice_no: 'INV123460',
        item_weight: 15.0,
        item_qty: 6,
        item_name: 'Steel Rods'
    },
    {
        id: 18,
        date: '2025-03-28',
        bookingNo: 'BOOK006',
        destination: { id: 106, name: 'Kolkata' },
        sender: { id: 206, name: 'Patna' },
        receiver: { id: 306, name: 'Guwahati' },
        items: [{ type: { id: 6, name: 'Food' }, item: 'Dry Rations', qty: 10, weight: 12, price: 6 }],
        freight: 600,
        surcharge: 20,
        stationary: 10,
        handling: 10,
        demurrage: 0,
        doorCollection: 20,
        doorDelivery: 20,
        insurance: 8,
        total_charge: 0,
        subtotal: 6,
        tax: 0.18,
        total: 6,
        comments: 'Perishable Goods',
        llr: 'LLR006',
        consignor: 'Arvind',
        consignee: 'Rita',
        branch: 'KOL',
        destinationCode: 'GUW',
        payment_status: 2,
        discount: 10,
        packageStatus: 3,
        modeOfDelivery: 1,
        from: 'Patna',
        to: 'Guwahati',
        lat: 22.5726,
        lng: 88.3639,
        title: 'Booking Title 6',
        description: 'Booking description 6',
        cancelNote: '',
        consignorDetails: {
            name: 'Arvind',
            address: '99 Market St, Patna',
            phone: '7890123450',
            gst: '10ABCDE4321F4Z5'
        },
        consigneeDetails: {
            name: 'Rita',
            address: '44 Hilltop, Guwahati',
            phone: '8901234560',
            gst: '18ABCDE5678F9Z0'
        },
        self_pickup: false,
        item_id: '67891',
        item_type: 'Food',
        item_price: 600,
        item_invoice_value: 680,
        item_invoice_date: '2025-11-06',
        item_invoice_no: 'INV123461',
        item_weight: 12.0,
        item_qty: 10,
        item_name: 'Dry Rations'
    },
    {
        id: 19,
        date: '2025-03-29',
        bookingNo: 'BOOK007',
        destination: { id: 107, name: 'Lucknow' },
        sender: { id: 207, name: 'Kanpur' },
        receiver: { id: 307, name: 'Agra' },
        items: [{ type: { id: 7, name: 'Electronics' }, item: 'Monitors', qty: 5, weight: 7, price: 7 }],
        freight: 720,
        surcharge: 25,
        stationary: 12,
        handling: 10,
        demurrage: 0,
        doorCollection: 18,
        doorDelivery: 22,
        insurance: 10,
        total_charge: 0,
        subtotal: 7,
        tax: 0.18,
        total: 7,
        comments: 'Display Units',
        llr: 'LLR007',
        consignor: 'Farhan',
        consignee: 'Vikas',
        branch: 'LKO',
        destinationCode: 'AGR',
        payment_status: 0,
        discount: 5,
        packageStatus: 1,
        modeOfDelivery: 2,
        from: 'Kanpur',
        to: 'Agra',
        lat: 26.8467,
        lng: 80.9462,
        title: 'Booking Title 7',
        description: 'Booking description 7',
        cancelNote: '',
        consignorDetails: {
            name: 'Farhan',
            address: '14 Civil Lines, Kanpur',
            phone: '9876512301',
            gst: '09ABCDE9999F1Z3'
        },
        consigneeDetails: {
            name: 'Vikas',
            address: '88 Yamuna Vihar, Agra',
            phone: '9012345678',
            gst: '09ABCDE8888F2Z4'
        },
        self_pickup: false,
        item_id: '78912',
        item_type: 'Electronics',
        item_price: 1000,
        item_invoice_value: 1050,
        item_invoice_date: '2025-11-07',
        item_invoice_no: 'INV123462',
        item_weight: 7.0,
        item_qty: 5,
        item_name: 'Monitors'
    },
    {
        id: 20,
        date: '2025-03-30',
        bookingNo: 'BOOK008',
        destination: { id: 108, name: 'Bhopal' },
        sender: { id: 208, name: 'Raipur' },
        receiver: { id: 308, name: 'Jabalpur' },
        items: [{ type: { id: 8, name: 'Books' }, item: 'Textbooks', qty: 20, weight: 12, price: 8 }],
        freight: 650,
        surcharge: 18,
        stationary: 9,
        handling: 12,
        demurrage: 0,
        doorCollection: 20,
        doorDelivery: 15,
        insurance: 7,
        total_charge: 0,
        subtotal: 8,
        tax: 0.18,
        total: 8,
        comments: 'Educational',
        llr: 'LLR008',
        consignor: 'Neeraj',
        consignee: 'Sanjay',
        branch: 'BPL',
        destinationCode: 'JBP',
        payment_status: 1,
        discount: 7,
        packageStatus: 2,
        modeOfDelivery: 1,
        from: 'Raipur',
        to: 'Jabalpur',
        lat: 23.2599,
        lng: 77.4126,
        title: 'Booking Title 8',
        description: 'Booking description 8',
        cancelNote: '',
        consignorDetails: {
            name: 'Neeraj',
            address: '55 Edu Lane, Raipur',
            phone: '9765432109',
            gst: '22ABCDE3333F5Z6'
        },
        consigneeDetails: {
            name: 'Sanjay',
            address: '22 Academy St, Jabalpur',
            phone: '9098765432',
            gst: '23ABCDE4444F6Z7'
        },
        self_pickup: false,
        item_id: '89123',
        item_type: 'Books',
        item_price: 300,
        item_invoice_value: 360,
        item_invoice_date: '2025-11-08',
        item_invoice_no: 'INV123463',
        item_weight: 12.0,
        item_qty: 20,
        item_name: 'Textbooks'
    },
    {
        id: 21,
        date: '2025-03-31',
        bookingNo: 'BOOK009',
        destination: { id: 109, name: 'Ranchi' },
        sender: { id: 209, name: 'Bhubaneswar' },
        receiver: { id: 309, name: 'Dhanbad' },
        items: [{ type: { id: 9, name: 'Cement' }, item: 'Bags', qty: 50, weight: 100, price: 9 }],
        freight: 980,
        surcharge: 20,
        stationary: 11,
        handling: 20,
        demurrage: 5,
        doorCollection: 15,
        doorDelivery: 10,
        insurance: 13,
        total_charge: 0,
        subtotal: 9,
        tax: 0.18,
        total: 9,
        comments: 'Construction load',
        llr: 'LLR009',
        consignor: 'Ravi',
        consignee: 'Arun',
        branch: 'RAN',
        destinationCode: 'DHD',
        payment_status: 0,
        discount: 10,
        packageStatus: 3,
        modeOfDelivery: 2,
        from: 'Bhubaneswar',
        to: 'Dhanbad',
        lat: 23.3441,
        lng: 85.3096,
        title: 'Booking Title 9',
        description: 'Booking description 9',
        cancelNote: '',
        consignorDetails: {
            name: 'Ravi',
            address: '88 Sector B, Bhubaneswar',
            phone: '9876501234',
            gst: '21ABCDE5555F7Z8'
        },
        consigneeDetails: {
            name: 'Arun',
            address: '77 Cement Rd, Dhanbad',
            phone: '8976543210',
            gst: '20ABCDE6666F8Z9'
        },
        self_pickup: false,
        item_id: '91234',
        item_type: 'Cement',
        item_price: 2000,
        item_invoice_value: 2200,
        item_invoice_date: '2025-11-09',
        item_invoice_no: 'INV123464',
        item_weight: 100.0,
        item_qty: 50,
        item_name: 'Cement Bags'
    },
    {
        id: 22,
        date: '2025-04-01',
        bookingNo: 'BOOK010',
        destination: { id: 110, name: 'Shimla' },
        sender: { id: 210, name: 'Chandigarh' },
        receiver: { id: 310, name: 'Manali' },
        items: [{ type: { id: 10, name: 'Medical' }, item: 'Syringes', qty: 100, weight: 5, price: 10 }],
        freight: 300,
        surcharge: 10,
        stationary: 5,
        handling: 10,
        demurrage: 0,
        doorCollection: 10,
        doorDelivery: 10,
        insurance: 5,
        total_charge: 0,
        subtotal: 10,
        tax: 0.18,
        total: 10,
        comments: 'Medical supplies',
        llr: 'LLR010',
        consignor: 'Prem',
        consignee: 'Arvind',
        branch: 'SHL',
        destinationCode: 'MAN',
        payment_status: 1,
        discount: 0,
        packageStatus: 1,
        modeOfDelivery: 1,
        from: 'Chandigarh',
        to: 'Manali',
        lat: 31.1048,
        lng: 77.1734,
        title: 'Booking Title 10',
        description: 'Booking description 10',
        cancelNote: '',
        consignorDetails: {
            name: 'Prem',
            address: '12 Sector 45, Chandigarh',
            phone: '9854678901',
            gst: '04ABCDE7777F9Z0'
        },
        consigneeDetails: {
            name: 'Arvind',
            address: '23 Snow Valley, Manali',
            phone: '9012345677',
            gst: '02ABCDE8888F0Z1'
        },
        self_pickup: false,
        item_id: '10234',
        item_type: 'Medical',
        item_price: 150,
        item_invoice_value: 180,
        item_invoice_date: '2025-11-10',
        item_invoice_no: 'INV123465',
        item_weight: 5.0,
        item_qty: 100,
        item_name: 'Syringes'
    },
    {
        id: 23,
        date: '2025-04-02',
        bookingNo: 'BOOK011',
        destination: { id: 111, name: 'Amritsar' },
        sender: { id: 211, name: 'Ludhiana' },
        receiver: { id: 311, name: 'Jalandhar' },
        items: [{ type: { id: 11, name: 'Garments' }, item: 'Jackets', qty: 15, weight: 9, price: 11 }],
        freight: 700,
        surcharge: 25,
        stationary: 15,
        handling: 10,
        demurrage: 0,
        doorCollection: 20,
        doorDelivery: 25,
        insurance: 8,
        total_charge: 0,
        subtotal: 11,
        tax: 0.18,
        total: 11,
        comments: 'Winter wear delivery',
        llr: 'LLR011',
        consignor: 'Harpreet',
        consignee: 'Manpreet',
        branch: 'AMR',
        destinationCode: 'JLD',
        payment_status: 0,
        discount: 5,
        packageStatus: 0,
        modeOfDelivery: 2,
        from: 'Ludhiana',
        to: 'Jalandhar',
        lat: 31.6340,
        lng: 74.8723,
        title: 'Booking Title 11',
        description: 'Booking description 11',
        cancelNote: '',
        consignorDetails: {
            name: 'Harpreet',
            address: '44 Cotton Rd, Ludhiana',
            phone: '9988776655',
            gst: '03ABCDE9999F1Z2'
        },
        consigneeDetails: {
            name: 'Manpreet',
            address: '12 Model Town, Jalandhar',
            phone: '9123456711',
            gst: '03ABCDE8888F2Z3'
        },
        self_pickup: false,
        item_id: '11234',
        item_type: 'Garments',
        item_price: 500,
        item_invoice_value: 600,
        item_invoice_date: '2025-11-11',
        item_invoice_no: 'INV123466',
        item_weight: 9.0,
        item_qty: 15,
        item_name: 'Jackets'
    },
    {
        id: 24,
        date: '2025-04-03',
        bookingNo: 'BOOK012',
        destination: { id: 112, name: 'Trivandrum' },
        sender: { id: 212, name: 'Kochi' },
        receiver: { id: 312, name: 'Kollam' },
        items: [{ type: { id: 12, name: 'Furniture' }, item: 'Chairs', qty: 12, weight: 20, price: 12 }],
        freight: 1050,
        surcharge: 30,
        stationary: 20,
        handling: 25,
        demurrage: 0,
        doorCollection: 15,
        doorDelivery: 20,
        insurance: 10,
        total_charge: 0,
        subtotal: 12,
        tax: 0.18,
        total: 12,
        comments: 'Office delivery',
        llr: 'LLR012',
        consignor: 'Abdul',
        consignee: 'Shyam',
        branch: 'TRV',
        destinationCode: 'KLM',
        payment_status: 1,
        discount: 10,
        packageStatus: 1,
        modeOfDelivery: 1,
        from: 'Kochi',
        to: 'Kollam',
        lat: 8.5241,
        lng: 76.9366,
        title: 'Booking Title 12',
        description: 'Booking description 12',
        cancelNote: '',
        consignorDetails: {
            name: 'Abdul',
            address: '88 Marine Drive, Kochi',
            phone: '9876543215',
            gst: '32ABCDE1234F5Z1'
        },
        consigneeDetails: {
            name: 'Shyam',
            address: '21 Residency Rd, Kollam',
            phone: '7890123456',
            gst: '32ABCDE5678F6Z2'
        },
        self_pickup: false,
        item_id: '12234',
        item_type: 'Furniture',
        item_price: 950,
        item_invoice_value: 1000,
        item_invoice_date: '2025-11-12',
        item_invoice_no: 'INV123467',
        item_weight: 20.0,
        item_qty: 12,
        item_name: 'Chairs'
    },
    {
        id: 25,
        date: '2025-04-04',
        bookingNo: 'BOOK013',
        destination: { id: 113, name: 'Pondicherry' },
        sender: { id: 213, name: 'Chennai' },
        receiver: { id: 313, name: 'Cuddalore' },
        items: [{ type: { id: 13, name: 'Stationery' }, item: 'Paper Reams', qty: 30, weight: 18, price: 13 }],
        freight: 560,
        surcharge: 18,
        stationary: 12,
        handling: 15,
        demurrage: 0,
        doorCollection: 10,
        doorDelivery: 15,
        insurance: 6,
        total_charge: 0,
        subtotal: 13,
        tax: 0.18,
        total: 13,
        comments: 'Bulk stationery',
        llr: 'LLR013',
        consignor: 'Dinesh',
        consignee: 'Lokesh',
        branch: 'PON',
        destinationCode: 'CDL',
        payment_status: 2,
        discount: 5,
        packageStatus: 2,
        modeOfDelivery: 2,
        from: 'Chennai',
        to: 'Cuddalore',
        lat: 11.9139,
        lng: 79.8145,
        title: 'Booking Title 13',
        description: 'Booking description 13',
        cancelNote: '',
        consignorDetails: {
            name: 'Dinesh',
            address: '25 Link Rd, Chennai',
            phone: '9876567891',
            gst: '33ABCDE9999F1Z4'
        },
        consigneeDetails: {
            name: 'Lokesh',
            address: '44 Beach View, Cuddalore',
            phone: '9012345676',
            gst: '33ABCDE8888F2Z5'
        },
        self_pickup: false,
        item_id: '13234',
        item_type: 'Office Supply',
        item_price: 300,
        item_invoice_value: 350,
        item_invoice_date: '2025-11-13',
        item_invoice_no: 'INV123468',
        item_weight: 18.0,
        item_qty: 30,
        item_name: 'Paper Reams'
    }
];

export const CANCELLED_BOOKINGS_DATA = [
    {
        id: 1,
        date: '05-11-2024',
        llr: 'KCI002',
        consignor: 'Sotret',
        consignee: 'Aryan',
        branch: 'KCI',
        branch_name: 'Karur Central',
        destination: 'PGT',
    },
    {
        id: 2,
        date: '04-11-2024',
        llr: 'VDI001',
        consignor: 'Muthu',
        consignee: 'Aryan',
        branch: 'VDI',
        branch_name: 'Vadipatti',
        destination: 'PGT',
    },
    {
        id: 3,
        date: '04-11-2024',
        llr: 'GNY002',
        consignor: 'Akash',
        consignee: 'Gopal',
        branch: 'GNY',
        branch_name: 'Gandhipuram North Yard',
        destination: 'PGT',
    },
    {
        id: 4,
        date: '04-11-2024',
        llr: 'EPM001',
        consignor: 'Mech',
        consignee: 'Rajesh',
        branch: 'EPM',
        branch_name: 'Erode Power Market',
        destination: 'PGT',
    },
    {
        id: 5,
        date: '04-11-2024',
        llr: 'PGT001',
        consignor: 'Tyson',
        consignee: 'Parker',
        branch: 'PGT',
        branch_name: 'Palakkad',
        destination: 'TWN',
    },
    {
        id: 6,
        date: '31-08-2024',
        llr: 'KTR004',
        consignor: 'Prabhu',
        consignee: 'Praveenkumar',
        branch: 'KTR',
        branch_name: 'Kottar',
        destination: 'TMS',
    },
    {
        id: 7,
        date: '31-08-2024',
        llr: 'KTR002',
        consignor: 'Prabhu',
        consignee: 'Gopi ram',
        branch: 'KTR',
        branch_name: 'Kottar',
        destination: 'TWN',
    },
];

export const BOOKING_STATEMENT_DATA = [
    {
        id: 1,
        date: '2024-11-05',
        llr: 'KCI002',
        consignor: 'Sotret',
        consignee: 'Aryan',
        branch: 'KCI',
        branch_name: 'Karur Central',
        destination: 'PGT',
        no_of_items: '0',
        freight: '0',
        stationary: '0',
        hamali: '0',
        dcollection: '0',
        ddelivary: '0',
        surcharge: '0',
        risk: '0',
        paid: '0',
        topay: '0',
    },
    {
        id: 2,
        date: '2024-11-04',
        llr: 'VDI001',
        consignor: 'Muthu',
        consignee: 'Aryan',
        branch: 'VDI',
        branch_name: 'Vadipatti',
        destination: 'PGT',
        no_of_items: '0',
        freight: '0',
        stationary: '0',
        hamali: '0',
        dcollection: '0',
        ddelivary: '0',
        surcharge: '0',
        risk: '0',
        paid: '0',
        topay: '0',
    },
    {
        id: 3,
        date: '2024-11-04',
        llr: 'GNY002',
        consignor: 'Akash',
        consignee: 'Gopal',
        branch: 'GNY',
        branch_name: 'Gandhipuram North Yard',
        destination: 'PGT',
        no_of_items: '0',
        freight: '0',
        stationary: '0',
        hamali: '0',
        dcollection: '0',
        ddelivary: '0',
        surcharge: '0',
        risk: '0',
        paid: '0',
        topay: '0',
    },
    {
        id: 4,
        date: '2024-11-04',
        llr: 'EPM001',
        consignor: 'Mech',
        consignee: 'Rajesh',
        branch: 'EPM',
        branch_name: 'Erode Power Market',
        destination: 'PGT',
        no_of_items: '0',
        freight: '0',
        stationary: '0',
        hamali: '0',
        dcollection: '0',
        ddelivary: '0',
        surcharge: '0',
        risk: '0',
        paid: '0',
        topay: '0',
    },
    {
        id: 5,
        date: '2024-11-04',
        llr: 'PGT001',
        consignor: 'Tyson',
        consignee: 'Parker',
        branch: 'PGT',
        branch_name: 'Palakkad',
        destination: 'TWN',
        no_of_items: '0',
        freight: '0',
        stationary: '0',
        hamali: '0',
        dcollection: '0',
        ddelivary: '0',
        surcharge: '0',
        risk: '0',
        paid: '0',
        topay: '0',
    },
    {
        id: 6,
        date: '2024-08-31',
        llr: 'KTR004',
        consignor: 'Prabhu',
        consignee: 'Praveenkumar',
        branch: 'KTR',
        branch_name: 'Kottar',
        destination: 'TMS',
        no_of_items: '0',
        freight: '0',
        stationary: '0',
        hamali: '0',
        dcollection: '0',
        ddelivary: '0',
        surcharge: '0',
        risk: '0',
        paid: '0',
        topay: '0',
    },
    {
        id: 7,
        date: '2024-08-31',
        llr: 'KTR002',
        consignor: 'Prabhu',
        consignee: 'Gopi ram',
        branch: 'KTR',
        branch_name: 'Kottar',
        destination: 'TWN',
        no_of_items: '0',
        freight: '0',
        stationary: '0',
        hamali: '0',
        dcollection: '0',
        ddelivary: '0',
        surcharge: '0',
        risk: '0',
        paid: '0',
        topay: '0',
    },
];
export const DELIVERY_STATEMENT_DATA = [
    {
        id: 1,
        date: '2024-11-05',
        llr: 'KCI002',
        consignor: 'Sotret',
        consignee: 'Aryan',
        branch: 'KCI',
        branch_name: 'Karur Central',
        destination: 'PGT',
        no_of_items: '0',
        freight: '0',
        stationary: '0',
        hamali: '0',
        dcollection: '0',
        ddelivary: '0',
        surcharge: '0',
        risk: '0',
        paid: '0',
        topay: '0',
    },
    {
        id: 2,
        date: '2024-11-04',
        llr: 'VDI001',
        consignor: 'Muthu',
        consignee: 'Aryan',
        branch: 'VDI',
        branch_name: 'Vadipatti',
        destination: 'PGT',
        no_of_items: '0',
        freight: '0',
        stationary: '0',
        hamali: '0',
        dcollection: '0',
        ddelivary: '0',
        surcharge: '0',
        risk: '0',
        paid: '0',
        topay: '0',
    },
    {
        id: 3,
        date: '2024-11-04',
        llr: 'GNY002',
        consignor: 'Akash',
        consignee: 'Gopal',
        branch: 'GNY',
        branch_name: 'Gandhipuram North Yard',
        destination: 'PGT',
        no_of_items: '0',
        freight: '0',
        stationary: '0',
        hamali: '0',
        dcollection: '0',
        ddelivary: '0',
        surcharge: '0',
        risk: '0',
        paid: '0',
        topay: '0',
    },
    {
        id: 4,
        date: '2024-11-04',
        llr: 'EPM001',
        consignor: 'Mech',
        consignee: 'Rajesh',
        branch: 'EPM',
        branch_name: 'Erode Power Market',
        destination: 'PGT',
        no_of_items: '0',
        freight: '0',
        stationary: '0',
        hamali: '0',
        dcollection: '0',
        ddelivary: '0',
        surcharge: '0',
        risk: '0',
        paid: '0',
        topay: '0',
    },
    {
        id: 5,
        date: '2024-11-04',
        llr: 'PGT001',
        consignor: 'Tyson',
        consignee: 'Parker',
        branch: 'PGT',
        branch_name: 'Palakkad',
        destination: 'TWN',
        no_of_items: '0',
        freight: '0',
        stationary: '0',
        hamali: '0',
        dcollection: '0',
        ddelivary: '0',
        surcharge: '0',
        risk: '0',
        paid: '0',
        topay: '0',
    },
    {
        id: 6,
        date: '2024-08-31',
        llr: 'KTR004',
        consignor: 'Prabhu',
        consignee: 'Praveenkumar',
        branch: 'KTR',
        branch_name: 'Kottar',
        destination: 'TMS',
        no_of_items: '0',
        freight: '0',
        stationary: '0',
        hamali: '0',
        dcollection: '0',
        ddelivary: '0',
        surcharge: '0',
        risk: '0',
        paid: '0',
        topay: '0',
    },
    {
        id: 7,
        date: '2024-08-31',
        llr: 'KTR002',
        consignor: 'Prabhu',
        consignee: 'Gopi ram',
        branch: 'KTR',
        branch_name: 'Kottar',
        destination: 'TWN',
        no_of_items: '0',
        freight: '0',
        stationary: '0',
        hamali: '0',
        dcollection: '0',
        ddelivary: '0',
        surcharge: '0',
        risk: '0',
        paid: '0',
        topay: '0',
    },
];

export const BOOKING_REPORT_DATA = [
    {
        id: 1,
        date: '2024-11-05',
        packages: "0",
        paid: '0',
        topay: '0',
        branch: 'KCI',
        branch_name: 'Karur Central',
    },
    {
        id: 2,
        date: '2024-11-04',
        packages: "0",
        paid: '0',
        topay: '0',
        branch: 'VDI',
        branch_name: 'Vadipatti',
    },
    {
        id: 3,
        date: '2024-11-04',
        packages: "0",
        paid: '0',
        topay: '0',
        branch: 'GNY',
        branch_name: 'Gandhipuram North Yard',
    },
    {
        id: 4,
        date: '2024-11-04',
        packages: "0",
        paid: '0',
        topay: '0',
        branch: 'EPM',
        branch_name: 'Erode Power Market',
    },
    {
        id: 5,
        date: '2024-11-04',
        packages: "0",
        paid: '0',
        topay: '0',
        branch: 'PGT',
        branch_name: 'Palakkad',
    },
    {
        id: 6,
        date: '2024-08-31',
        packages: "0",
        paid: '0',
        topay: '0',
        branch: 'KTR',
        branch_name: 'Kottar',
    },
    {
        id: 7,
        date: '2024-08-31',
        packages: "0",
        paid: '0',
        topay: '0',
        branch: 'KTR',
        branch_name: 'Kottar',
    },
];
export const DELIVERY_REPORT_DATA = [
    {
        id: 1,
        date: '05-11-2024',
        packages: "0",
        paid: '0',
        topay: '0',
        branch: 'KCI',
        branch_name: 'Karur Central',
    },
    {
        id: 2,
        date: '04-11-2024',
        packages: "0",
        paid: '0',
        topay: '0',
        branch: 'VDI',
        branch_name: 'Vadipatti',
    },
    {
        id: 3,
        date: '04-11-2024',
        packages: "0",
        paid: '0',
        topay: '0',
        branch: 'GNY',
        branch_name: 'Gandhipuram North Yard',
    },
    {
        id: 4,
        date: '04-11-2024',
        packages: "0",
        paid: '0',
        topay: '0',
        branch: 'EPM',
        branch_name: 'Erode Power Market',
    },
    {
        id: 5,
        date: '04-11-2024',
        packages: "0",
        paid: '0',
        topay: '0',
        branch: 'PGT',
        branch_name: 'Palakkad',
    },
    {
        id: 6,
        date: '31-08-2024',
        packages: "0",
        paid: '0',
        topay: '0',
        branch: 'KTR',
        branch_name: 'Kottar',
    },
    {
        id: 7,
        date: '31-08-2024',
        packages: "0",
        paid: '0',
        topay: '0',
        branch: 'KTR',
        branch_name: 'Kottar',
    },
];
export const BOOKING_SUMMARY_DATA = [
    {
        id: 1,
        date: '2024-11-05',
        grandtotal: "0",
        paid: '0',
        topay: '0',
    },
    {
        id: 2,
        date: '2024-11-04',
        grandtotal: "0",
        paid: '0',
        topay: '0',
    },
    {
        id: 3,
        date: '2024-11-04',
        grandtotal: "0",
        paid: '0',
        topay: '0',
    },
    {
        id: 4,
        date: '2024-11-04',
        grandtotal: "0",
        paid: '0',
        topay: '0',
    },
    {
        id: 5,
        date: '2024-11-04',
        grandtotal: "0",
        paid: '0',
        topay: '0',
    },
    {
        id: 6,
        date: '2024-08-31',
        grandtotal: "0",
        paid: '0',
        topay: '0',
    },
    {
        id: 7,
        date: '2024-08-31',
        grandtotal: "0",
        paid: '0',
        topay: '0',
    },
];
export const DELIVERY_SUMMARY_DATA = [
    {
        id: 1,
        date: '05-11-2024',
        grandtotal: "0",
        paid: '0',
        topay: '0',
    },
    {
        id: 2,
        date: '04-11-2024',
        grandtotal: "0",
        paid: '0',
        topay: '0',
    },
    {
        id: 3,
        date: '04-11-2024',
        grandtotal: "0",
        paid: '0',
        topay: '0',
    },
    {
        id: 4,
        date: '04-11-2024',
        grandtotal: "0",
        paid: '0',
        topay: '0',
    },
    {
        id: 5,
        date: '04-11-2024',
        grandtotal: "0",
        paid: '0',
        topay: '0',
    },
    {
        id: 6,
        date: '31-08-2024',
        grandtotal: "0",
        paid: '0',
        topay: '0',
    },
    {
        id: 7,
        date: '31-08-2024',
        grandtotal: "0",
        paid: '0',
        topay: '0',
    },
];

export const USER_DATA = [
    {
        id: 1,
        branch: { id: 'KCI', name: 'Kochi, Kochi' },
        userName: 'Kochi',
        email: 'Kochi@gmail.com',
        role: { id: 'franchise', name: 'Franchise' },
        status: { id: 1, name: 'Active' },
        firstName: 'Kochi',
        lastName: 'Aluva',
        password: '',
        changePasswordOnLogin: false
    },
    {
        id: 2,
        branch: { id: 'VDI', name: 'Vadavalli, COIMBATORE' },
        userName: 'Vadavalli',
        email: 'Vadavalli@gmail.com',
        role: { id: 'franchise', name: 'Franchise' },
        status: { id: 2, name: 'Inactive' },
        firstName: 'Vadavalli',
        lastName: 'Coimbatore',
        password: '',
        changePasswordOnLogin: false
    },
    {
        id: 3,
        branch: { id: 'EPM', name: 'EdiyaPalayam, Coimbatore' },
        userName: 'EdiyarPalayam',
        email: 'ediyarpalayam@gmail.com',
        role: { id: 'franchise', name: 'Franchise' },
        status: { id: 2, name: 'Inactive' },
        firstName: 'Ediyar',
        lastName: '',
        password: '',
        changePasswordOnLogin: false
    },
    {
        id: 4,
        branch: { id: 'GNY', name: 'Ganapathy, Coimbatore' },
        userName: 'Ganapathy',
        email: 'ganapathy@gmail.com',
        role: { id: 'franchise', name: 'Franchise' },
        status: { id: 1, name: 'Active' },
        firstName: 'Ganapathy',
        lastName: 'Murugan',
        password: '',
        changePasswordOnLogin: false
    },
    {
        id: 5,
        branch: { id: 'KTR', name: 'KATTOOR, COIMBATORE' },
        userName: 'automan',
        email: 'aurodriver',
        role: { id: 'franchise', name: 'Franchise' },
        status: { id: 1, name: 'Active' },
        firstName: 'Coimbatore',
        lastName: 'Tamilnadu',
        password: '',
        changePasswordOnLogin: false
    },
    {
        id: 6,
        branch: { id: 'TMS', name: 'CBETHOMAS, COIMBATORE' },
        userName: 'Driver',
        email: 'Driverlogin@gmail.com',
        role: { id: 'franchise', name: 'Franchise' },
        status: { id: 2, name: 'Inactive' },
        firstName: 'Driver',
        lastName: 'New',
        password: '',
        changePasswordOnLogin: false
    },
    {
        id: 7,
        branch: { id: 'KTR', name: 'KATTOOR, COIMBATORE' },
        userName: 'ganapati',
        email: 'ganapati@gmail.com',
        role: { id: 'franchise', name: 'Franchise' },
        status: { id: 1, name: 'Active' },
        firstName: 'Ganapati',
        lastName: '',
        password: '',
        changePasswordOnLogin: false
    },
    {
        id: 8,
        branch: { id: 'KTR', name: 'KATTOOR, COIMBATORE' },
        userName: 'ganapati',
        email: 'ganapati@gmail.com',
        role: { id: 'franchise', name: 'Franchise' },
        status: { id: 1, name: 'Active' },
        firstName: 'New',
        lastName: 'Driver',
        password: '',
        changePasswordOnLogin: false
    },
    {
        id: 9,
        branch: { id: 'TMS', name: 'CBETHOMAS, COIMBATORE' },
        userName: 'Accounts',
        email: 'accountsdepartment@gmail.com',
        role: { id: 'account', name: 'Accounts Department' },
        status: { id: 1, name: 'Active' },
        firstName: 'Accounts',
        lastName: 'Department',
        password: '',
        changePasswordOnLogin: false
    },
    {
        id: 10,
        branch: { id: 'TMS', name: 'CBETHOMAS, COIMBATORE' },
        userName: 'Admin',
        email: 'Administrator@gmail.com',
        role: { id: 'admin', name: 'Administrator' },
        status: { id: 1, name: 'Active' },
        firstName: 'Super',
        lastName: 'Admin',
        password: '',
        changePasswordOnLogin: false
    }
];
export const TRIP_DATA = [
    {
        id: 1,
        date: '15-11-2024',
        tripNo: 'TMS016',
        vehicle: { id: 'TN66AF5478', name: 'TN66AF5478' },
        driver: { id: 'murugan', name: 'Murugan' },
        pickupBranch: [{ id: 'CMS', name: 'COIMBATORE' }],
        deliveryBranches: [
            { id: 'PLK', name: 'PALAKKAD' }
        ]
    },
    {
        id: 2,
        date: '23-10-2024',
        tripNo: 'TMS009',
        vehicle: { id: 'TN38BC3645', name: 'TN38BC3645' },
        driver: { id: 'rajkumar', name: 'Rajkumar' },
        pickupBranch: [{ id: 'TMS', name: 'CBETHOMAS' }, { id: 'CMS', name: 'COIMBATORE' }],
        deliveryBranches: [
            { id: 'CBT', name: 'CBETOWN' },
            { id: 'KTR', name: 'KATTOOR' },
            { id: 'PLK', name: 'PALAKKAD' }
        ]
    }
];

export const CUSTOMERS_DATA = [
    {
        id: 1,
        name: 'Sotret',
        mobile: '123',
        gst: '123fg',
        city: 'Kochi',
        branchLocation: { id: 'KCI', name: 'Kochi' },
        address: '123 Street, Kochi',
        state: 'Kerala',
        landmark: 'Near MG Road',
        postalCode: '682001',
        landline: '0484-1234567',
        email: 'sotret@example.com',
        isSelf: false
    },
    {
        id: 2,
        name: 'closed',
        mobile: '1234',
        gst: 'fgh6543',
        city: 'Coimbatore',
        branchLocation: { id: 'EPM', name: 'EdiyarPalayam' },
        address: '456 Main Rd',
        state: 'Tamil Nadu',
        landmark: 'Next to Bus Stand',
        postalCode: '641001',
        landline: '0422-8765432',
        email: 'closed@example.com',
        isSelf: true
    },
    {
        id: 3,
        name: 'Open',
        mobile: '2344',
        gst: '23df',
        city: 'Palakkad',
        branchLocation: { id: 'PLK', name: 'PALAKKAD' },
        address: 'Plot No 10',
        state: 'Kerala',
        landmark: 'Opposite Mall',
        postalCode: '678001',
        landline: '0491-112233',
        email: 'open@example.com',
        isSelf: false
    },
    {
        id: 4,
        name: 'CREAM',
        mobile: '5678',
        gst: '67HJ',
        city: 'COIMBATORE',
        branchLocation: { id: 'GNY', name: 'Ganapathy' },
        address: 'New Industrial Area',
        state: 'Tamil Nadu',
        landmark: 'Behind Flyover',
        postalCode: '641006',
        landline: '0422-334455',
        email: 'cream@example.com',
        isSelf: true
    }
];

export const RECEIVERS_DATA = [
    {
        id: 1,
        name: 'Sotret',
        mobile: '123',
        gst: '123fg',
        city: 'Kochi',
        address: '123 Street, Kochi',
        state: 'Kerala',
        landmark: 'Near MG Road',
        postalCode: '682001',
        landline: '0484-1234567',
        email: 'sotret@example.com',
        isSelf: false
    },
    {
        id: 2,
        name: 'closed',
        mobile: '1234',
        gst: 'fgh6543',
        city: 'Coimbatore',
        address: '456 Main Rd',
        state: 'Tamil Nadu',
        landmark: 'Next to Bus Stand',
        postalCode: '641001',
        landline: '0422-8765432',
        email: 'closed@example.com',
        isSelf: true
    },
    {
        id: 3,
        name: 'Open',
        mobile: '2344',
        gst: '23df',
        city: 'Palakkad',
        address: 'Plot No 10',
        state: 'Kerala',
        landmark: 'Opposite Mall',
        postalCode: '678001',
        landline: '0491-112233',
        email: 'open@example.com',
        isSelf: false
    },
    {
        id: 4,
        name: 'CREAM',
        mobile: '5678',
        gst: '67HJ',
        city: 'COIMBATORE',
        address: 'New Industrial Area',
        state: 'Tamil Nadu',
        landmark: 'Behind Flyover',
        postalCode: '641006',
        landline: '0422-334455',
        email: 'cream@example.com',
        isSelf: true
    }
];

export const BRANCHES_DATA = [
    {
        id: 1,
        branchName: 'Gandhipuram',
        branchCode: 'GPM',
        address: '100 MG Road',
        postalCode: '641012',
        landline: '0422-2233445',
        IsMainBranch: { id: 1, name: 'Yes' },
        mainBranch: { id: 2, name: '' },
        hub: { id: 2, name: 'No' },
        city: 'Coimbatore',
        email: 'gandhipuram@gmail.com',
        contact: '12345434',
        status: { id: 1, name: 'Active' }
    },
    {
        id: 2,
        branchName: 'Vadavalli',
        branchCode: 'VDI',
        address: '22 Main Street',
        postalCode: '641041',
        landline: '0422-1122334',
        IsMainBranch: { id: 2, name: 'No' },
        mainBranch: { id: 2, name: 'CBETHOMAS' },
        hub: { id: 2, name: 'No' },
        city: 'COIMBATORE',
        email: 'Vadavalli@gmail.com',
        contact: '123456',
        status: { id: 2, name: 'Inactive' }
    },
    {
        id: 3,
        branchName: 'Vadavalli',
        branchCode: 'VDV',
        address: 'Near Anna University',
        postalCode: '641046',
        landline: '0422-987654',
        IsMainBranch: { id: 2, name: 'No' },
        mainBranch: { id: 1, name: 'CBETOWN' },
        hub: { id: 1, name: 'Yes' },
        city: 'Coimbatore',
        email: 'vdv@dm.com',
        contact: '9869869',
        status: { id: 1, name: 'Active' }
    },
    {
        id: 4,
        branchName: 'EdiyarPalayam',
        branchCode: 'EPM',
        address: 'New Bus Stand Road',
        postalCode: '641028',
        landline: '0422-3344556',
        IsMainBranch: { id: 1, name: 'Yes' },
        mainBranch: { id: 1, name: '' },
        hub: { id: 1, name: 'Yes' },
        city: 'Coimbatore',
        email: 'EdiyarPalayam@gmail.com',
        contact: '12345',
        status: { id: 1, name: 'Active' }
    },
    {
        id: 5,
        branchName: 'Ganapathy',
        branchCode: 'GNY',
        address: 'Opp to SBI ATM',
        postalCode: '641006',
        landline: '0422-5566778',
        IsMainBranch: { id: 2, name: 'No' },
        mainBranch: { id: 2, name: 'CBETHOMAS' },
        hub: { id: 2, name: 'No' },
        city: 'Coimbatore',
        email: 'ganapathy@gmail.com',
        contact: '8197019213',
        status: { id: 2, name: 'Inactive' }
    }
];

export const VEHICLES_DATA = [
    {
        id: 1,
        vehicleNo: 'TN66AF5478',
        vehicleType: 'TRUCK',
        ownerName: 'MURALI',
        ownerContact: '876543',
        rcNo: '123',
        insuranceNo: '123',
        insuranceExp: '22-10-2025',
        fcExp: '20-12-2029',
        panNo: '34567U',
        address: '12, MG Road, Coimbatore'
    },
    {
        id: 2,
        vehicleNo: 'TN38BC3645',
        vehicleType: 'Truck',
        ownerName: 'Praveen',
        ownerContact: '1234567890',
        rcNo: '234567',
        insuranceNo: '234567',
        insuranceExp: '20-05-2025',
        fcExp: '14-11-2028',
        panNo: '345678',
        address: '45, DB Road, Erode'
    }
];

export const DRIVERS_DATA = [
    {
        id: 1,
        name: 'Raja',
        licenceNo: 'TN55 2024 0001234',
        licenceExp: '15-09-2027',
        mobile: '9876543210',
        address: '12, Mount Road, Chennai'
    },
    {
        id: 2,
        name: 'Suresh',
        licenceNo: 'TN07 2022 4567890',
        licenceExp: '01-01-2026',
        mobile: '9123456789',
        address: '23, Avinashi Road, Coimbatore'
    }
];

export const QUOTATIONs_DATA = [
    {
        id: 1,
        quotationNo: 'TMS001',
        date: '2024-04-01',
        destination: { id: 101, name: 'Chennai' },
        sender: { id: 201, name: 'Coimbatore' },
        receiver: { id: 301, name: 'Madurai' },
        items: [
            {
                type: { id: 1, name: 'Parcel' },
                item: 'Electronics',
                qty: 1,
                weight: 1,
                price: 1
            }
        ],
        freight: 1,
        surcharge: 1,
        stationary: 1,
        handling: 1,
        demurrage: 1,
        door_collect: 1,
        door_delivery: 1,
        insurance: 1,
        total_charge: 0,
        subtotal: 1,
        tax: 0.18,
        total: 1,
        comments: 'Basic shipment'
    },
    {
        id: 2,
        quotationNo: 'TMS002',
        date: '2024-04-03',
        destination: { id: 102, name: 'Delhi' },
        sender: { id: 202, name: 'Mumbai' },
        receiver: { id: 302, name: 'Pune' },
        items: [
            {
                type: { id: 2, name: 'Document' },
                item: 'Legal Papers',
                qty: 2,
                weight: 2,
                price: 4
            }
        ],
        freight: 1,
        surcharge: 1,
        stationary: 1,
        handling: 1,
        demurrage: 1,
        door_collect: 1,
        door_delivery: 1,
        insurance: 1,
        total_charge: 16,
        subtotal: 20,
        tax: 3.6,
        total: 20,
        comments: 'Priority courier'
    },
    {
        id: 3,
        quotationNo: 'TMS003',
        date: '2024-04-05',
        destination: { id: 103, name: 'Bangalore' },
        sender: { id: 203, name: 'Hyderabad' },
        receiver: { id: 303, name: 'Vizag' },
        items: [
            {
                type: { id: 3, name: 'Cargo' },
                item: 'Industrial Tools',
                qty: 3,
                weight: 3,
                price: 9
            }
        ],
        freight: 1,
        surcharge: 1,
        stationary: 1,
        handling: 1,
        demurrage: 1,
        door_collect: 1,
        door_delivery: 1,
        insurance: 1,
        total_charge: 16,
        subtotal: 25,
        tax: 4.5,
        total: 25,
        comments: 'Heavy cargo'
    }
];

export const ALL_PERMISSIONS_DATA = [
    {
        id: 1,
        title: 'Bookings',
        permissions: [
            { id: 101, name: 'Create Bookings' },
            { id: 102, name: 'Edit Bookings' },
            { id: 103, name: 'View Bookings' },
            { id: 104, name: 'Delete Bookings' },
            { id: 105, name: 'Print / Export Bookings' },
        ],
    },
    {
        id: 2,
        title: 'Quotations',
        permissions: [
            { id: 201, name: 'Create Quotations' },
            { id: 202, name: 'Edit Quotations' },
            { id: 203, name: 'View Quotations' },
            { id: 204, name: 'Delete Quotations' },
            { id: 205, name: 'Print / Export Quotations' },
        ],
    },
    {
        id: 3,
        title: 'Users',
        permissions: [
            { id: 301, name: 'Create Users' },
            { id: 302, name: 'Edit Users' },
            { id: 303, name: 'View Users' },
            { id: 304, name: 'Delete Users' },
            { id: 305, name: 'Print / Export Users' },
        ],
    },
    {
        id: 4,
        title: 'Customers',
        permissions: [
            { id: 401, name: 'Create Customers' },
            { id: 402, name: 'Edit Customers' },
            { id: 403, name: 'View Customers' },
            { id: 404, name: 'Delete Customers' },
            { id: 405, name: 'Print / Export Customers' },
        ],
    },
    {
        id: 5,
        title: 'Vehicles',
        permissions: [
            { id: 501, name: 'Create Vehicles' },
            { id: 502, name: 'Edit Vehicles' },
            { id: 503, name: 'View Vehicles' },
            { id: 504, name: 'Delete Vehicles' },
            { id: 505, name: 'Print / Export Vehicles' },
        ],
    },
    {
        id: 6,
        title: 'Drivers',
        permissions: [
            { id: 601, name: 'Create Drivers' },
            { id: 602, name: 'Edit Drivers' },
            { id: 603, name: 'View Drivers' },
            { id: 604, name: 'Delete Drivers' },
            { id: 605, name: 'Print / Export Drivers' },
        ],
    },
    {
        id: 7,
        title: 'Branches',
        permissions: [
            { id: 701, name: 'Create Branches' },
            { id: 702, name: 'Edit Branches' },
            { id: 703, name: 'View Branches' },
            { id: 704, name: 'Delete Branches' },
            { id: 705, name: 'Print / Export Branches' },
        ],
    },
    {
        id: 8,
        title: 'Roles',
        permissions: [
            { id: 801, name: 'Create Roles' },
            { id: 802, name: 'Edit Roles' },
            { id: 803, name: 'View Roles' },
            { id: 804, name: 'Delete Roles' },
        ],
    },
    {
        id: 9,
        title: 'Trips',
        permissions: [
            { id: 901, name: 'Create Trips' },
            { id: 902, name: 'Edit Trips' },
            { id: 903, name: 'View Trips' },
            { id: 904, name: 'Delete Trips' },
            { id: 905, name: 'Print / Export Trips' },
        ],
    },
    {
        id: 10,
        title: 'Reports',
        permissions: [
            { id: 1001, name: 'View Reports' },
            { id: 1002, name: 'View Booking Statement' },
            { id: 1003, name: 'View Booking Report' },
            { id: 1004, name: 'View Booking Summary' },
            { id: 1005, name: 'View Booking Status Report' },
            { id: 1006, name: 'View Delivery Statement' },
            { id: 1007, name: 'View Delivery Report' },
            { id: 1008, name: 'View Delivery Summary' },
            { id: 1009, name: 'View Customer Report' },
            { id: 1010, name: 'View Vehicle Report' },
            { id: 1011, name: 'View Cancelled Bookings' },
            { id: 1012, name: 'Print / Export Reports' },
        ],
    },
];

export const ROLES_DATA = [
    {
        id: 1,
        role_name: 'Admin',
        created_by: 'System',
        modified_by: 'System',
        created_at: '2024-01-01',
        modified_at: '2024-01-01',
        permission_id: [
            101, 102, 103, 104, 105,   // Bookings
            201, 202, 203, 204, 205,   // Quotations
            301, 302, 303, 304, 305,   // Users
            401, 402, 403, 404, 405,   // Customers
            801, 802, 803, 804         // Roles
        ]
    },
    {
        id: 2,
        role_name: 'Manager',
        created_by: 'Admin',
        modified_by: 'Admin',
        created_at: '2024-01-10',
        modified_at: '2024-02-01',
        permission_id: [
            201, 203, 205,             // Quotations
            301, 303,                  // Users
            1001, 1002, 1003, 1012     // Reports
        ]
    },
    {
        id: 3,
        role_name: 'Viewer',
        created_by: 'Admin',
        modified_by: 'Manager',
        created_at: '2024-01-15',
        modified_at: '2024-02-05',
        permission_id: [
            1001, 1002, 1003, 1004, 1005,
            1006, 1007, 1008, 1009, 1010, 1011
        ]
    }
];

